import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

const useStyles = makeStyles((theme) => ({
  defaultMenu: {
    "& .MuiSelect-select": {
      background: theme.palette.MDCColors.color21,
      border: `2px solid ${theme.palette.MDCColors.color23}`,
      color: theme.palette.MDCColors.color18,
      fontFamily: theme.palette.typography.fontFamily,
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      marginTop: "0.625rem",
      fontSize: "1rem",
      padding: (props) =>
        props.isSmall
          ? "0.438rem 0 0.438rem 0.625rem"
          : "0.563rem 0 0.438rem 0.625rem",
      height: (props) =>
        props.isSmall
          ? "calc(1rem + 0.01rem + 0.625rem)"
          : "calc(1rem + 0.172rem + 0.625rem)",
      borderRadius: "5px",
      "&:focus": {
        backgroundColor: theme.palette.MDCColors.color21,
        borderRadius: "5px",
      },
    },
    "& .MuiSelect-icon": {
      top: "calc(50% - 0.625rem)",
      color: theme.palette.MDCColors.color23,
    },
  },
  filterMenu: {
    width: (props) => props.filterMenuWidth || "100%",
    maxWidth: (props) => props.filterMenuWidth || "100%",
    minWidth: 0,
    boxSizing: "border-box",
    "& .MuiSelect-select": {
      background: theme.palette.MDCColors.white,
      border: "0px",
      borderRadius: "0rem",
      padding: "0.625rem 0.625rem 0rem 0.938rem !important",
      height: "calc(1rem + 0.625rem + 0.625rem) !important",
      marginTop: "0rem",
      "&:focus": {
        backgroundColor: theme.palette.MDCColors.white,
        borderRadius: "0px",
      },
      paddingTop: "0 !important",
      paddingBottom: "0 !important",
      display: "flex",
      alignItems: "center",
      lineHeight: "1.1876rem",
    },
    "& .MuiSelect-icon": {
      color: theme.palette.MDCColors.color23,
    },
  },
  disabledMenu: {
    "& .MuiSelect-select": {
      border: "0px",
      height: (props) => props.isSmall && "calc(1rem + 0.0172rem + 0.625rem)",
      padding: (props) => props.isSmall && "0.983rem 0 0rem 0.938rem",
    },
    "& .MuiSelect-icon": {
      color: theme.palette.MDCColors.disabledColor,
    },
  },
  errorMenu: {
    "& .MuiSelect-select": {
      border: `2px solid ${theme.palette.MDCColors.errorDanger}`,
      background: "rgba(236, 88, 103, 0.3)",
      "&:focus": {
        backgroundColor: "rgba(236, 88, 103, 0.3)",
      },
    },
    "& .MuiSelect-icon": {
      color: theme.palette.MDCColors.textColor,
    },
  },
  menuItemCSS: {
    fontFamily: theme.palette.typography.fontFamily,
  },
  filterSelectedValue: {
    display: "block",
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
}));

const MDCSelect = (props) => {
  const {
    value,
    handleChange,
    options,
    name,
    disabled,
    isfilterMenu,
    error,
    placeholder,
    disableEmpty,
    showAlleOption,
    disabledOptions,
  } = props;

  const selectOptions = options || [];

  const {
    defaultMenu,
    filterMenu,
    disabledMenu,
    errorMenu,
    menuItemCSS,
    filterSelectedValue,
  } = useStyles(props);

  let MDCStyles = defaultMenu;
  if (isfilterMenu) {
    MDCStyles = `${MDCStyles} ${filterMenu}`;
  }
  if (disabled) {
    MDCStyles = `${MDCStyles} ${disabledMenu}`;
  }
  if (error) {
    MDCStyles = `${MDCStyles} ${errorMenu}`;
  }

  const [selected, setSelected] = useState([]);

  const handleAllChange = (event) => {
    const value = event.target.value;

    // If "Select All" is selected
    if (value === "Alle") {
      setSelected(
        selected.length === selectOptions.length ? [] : selectOptions
      );
      handleChange(event);
    } else {
      setSelected([]);
      handleChange(event);
    }
  };

  let selectedOptions = [];

  selectedOptions = showAlleOption
    ? [{ label: "Alle", value: "Alle", all: true }, ...selectOptions]
    : selectOptions;

  return (
    <>
      <Select
        name={name}
        value={value}
        onChange={showAlleOption ? handleAllChange : handleChange}
        disabled={disabled}
        displayEmpty
        fullWidth
        className={MDCStyles}
        variant="standard"
        disableUnderline
        renderValue={(selected) => {
          if (isfilterMenu) {
            const alleLabel = selectedOptions?.find(
              (option) => option?.label === "Alle"
            )?.label;
            let selectedLabel = "";
            if (selected) {
              selectedLabel = selectedOptions?.find(
                (option) => option?.value === value
              )?.label;
            } else if (alleLabel) {
              selectedLabel = "Alle";
            }

            return <span className={filterSelectedValue}>{selectedLabel}</span>;
          } else {
            if (selected && selected !== "Alle") {
              return selectedOptions?.find((option) => option?.value === value)
                ?.label;
            } else if (selected === "Alle") {
              return "Alle";
            } else if (!selected) {
              return placeholder;
            }
          }
        }}
      >
        {placeholder && (
          <MenuItem disabled={disableEmpty} value="" className={menuItemCSS}>
            <div>{placeholder}</div>
          </MenuItem>
        )}

        {selectedOptions?.map((option, index) => (
          <MenuItem
            key={index}
            value={option?.value}
            className={menuItemCSS}
            disabled={
              option?.disabled ||
              disabledOptions?.includes(option.value) ||
              disabledOptions?.includes(option.label)
            }
          >
            {option?.label}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

export default MDCSelect;
